import { render, staticRenderFns } from "./ShowBranch.vue?vue&type=template&id=4acec54b&"
import script from "./ShowBranch.vue?vue&type=script&lang=js&"
export * from "./ShowBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports